import { useEffect, useMemo, useState } from "react";
import { ProteinRow } from "../types/protein-row";
import { ProteinResponse } from "../../../api/openapi-generator";
import { ProteinApi } from "../../../api";
import { comparator, groupBy } from "../../../utils/tools";

function trimIsoformSuffix({ code }: ProteinResponse): string {
  // return protein code without isoform suffix
  const lastDot = code.lastIndexOf('.');
  return lastDot > 0 ? code.substring(0, lastDot) : code;
}

export function useProteinRows() {
  const [targets, setTargets] = useState<ProteinResponse[]>([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    ProteinApi.list()
      .then(targets => {
        // gene name: upper case
        targets.forEach(item => item.geneName = item.geneName.toUpperCase());
        if (!cancelled) {
          setTargets(targets);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setFailed(true);
          console.error(err);
        }
      })

    return () => {
      cancelled = true;
      setTargets([]);
      setFailed(false);
    }
  }, []);

  const rows = useMemo(() => {
    // group targets
    const rows: ProteinRow[] = Object.entries(groupBy(targets, trimIsoformSuffix)).map(
      ([code, proteins]) => ({
        ...proteins[0],
        code,
        proteins,
      }));
    // sort known target rows by Protein code, case-insensitive
    rows.sort(comparator(t => t.code.toLowerCase()));
    return rows;
  }, [targets]);

  return {targets, failed, rows};
}